import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { init } from '@ap/sentry';

import { MijnLoginComponent } from './mijn-login.component';
import { appConfig } from './app.config';

registerLocaleData(localeNl, 'nl');
// @ts-ignore: Needs to be ignored so the typescript compiler replaces CONFIGURATION
export const configuration: string = CONFIGURATION;

if (configuration !== 'development') {
    init();
    enableProdMode();
}

bootstrapApplication(MijnLoginComponent, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] }).catch((err) =>
    console.error(err)
); //NOSONAR
